var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * 
 * @file Preview header component
 * @author Box
 */

import React from 'react';
import { injectIntl } from 'react-intl';
import PlainButton from 'box-react-ui/lib/components/plain-button/PlainButton';
import IconClose from 'box-react-ui/lib/icons/general/IconClose';
import IconDrawAnnotationMode from 'box-react-ui/lib/icons/annotations/IconDrawAnnotation';
import IconPointAnnotation from 'box-react-ui/lib/icons/annotations/IconPointAnnotation';
import IconPrint from 'box-react-ui/lib/icons/general/IconPrint';
import IconDownload from 'box-react-ui/lib/icons/general/IconDownloadSolid';
import messages from '../messages';
import { getIcon } from '../Item/iconCellRenderer';
import { COLOR_999 } from '../../constants';
import ContentOpenWith from '../ContentOpenWith/ContentOpenWith';


var Header = function Header(_ref) {
    var canAnnotate = _ref.canAnnotate,
        canDownload = _ref.canDownload,
        _ref$contentOpenWithP = _ref.contentOpenWithProps,
        contentOpenWithProps = _ref$contentOpenWithP === undefined ? {} : _ref$contentOpenWithP,
        file = _ref.file,
        intl = _ref.intl,
        onClose = _ref.onClose,
        onDownload = _ref.onDownload,
        onPrint = _ref.onPrint,
        token = _ref.token;

    var name = file ? file.name : '';
    var id = file && file.id;
    var closeMsg = intl.formatMessage(messages.close);
    var printMsg = intl.formatMessage(messages.print);
    var downloadMsg = intl.formatMessage(messages.download);
    var drawMsg = intl.formatMessage(messages.drawAnnotation);
    var pointMsg = intl.formatMessage(messages.pointAnnotation);
    var shouldRenderOpenWith = id && contentOpenWithProps.show;

    return React.createElement(
        'div',
        { className: 'bcpr-header' },
        React.createElement(
            'div',
            { className: 'bp-header bp-base-header' },
            React.createElement(
                'div',
                { className: 'bcpr-name' },
                file ? getIcon(24, file) : null,
                React.createElement(
                    'span',
                    null,
                    name
                )
            ),
            React.createElement(
                'div',
                { className: 'bcpr-btns' },
                shouldRenderOpenWith && React.createElement(ContentOpenWith, _extends({
                    className: 'bcpr-bcow-btn',
                    fileId: id,
                    token: token
                }, contentOpenWithProps)),
                canAnnotate && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                        PlainButton,
                        {
                            type: 'button',
                            className: 'bcpr-btn bp-btn-annotate-draw bp-is-hidden',
                            title: drawMsg,
                            'aria-label': drawMsg
                        },
                        React.createElement(IconDrawAnnotationMode, {
                            color: COLOR_999,
                            width: 18,
                            height: 18
                        })
                    ),
                    React.createElement(
                        PlainButton,
                        {
                            type: 'button',
                            className: 'bcpr-btn bp-btn-annotate-point bp-is-hidden',
                            title: pointMsg,
                            'aria-label': pointMsg
                        },
                        React.createElement(IconPointAnnotation, {
                            color: COLOR_999,
                            width: 18,
                            height: 18
                        })
                    )
                ),
                canDownload && React.createElement(
                    PlainButton,
                    {
                        type: 'button',
                        className: 'bcpr-btn',
                        onClick: onPrint,
                        title: printMsg,
                        'aria-label': printMsg
                    },
                    React.createElement(IconPrint, {
                        color: COLOR_999,
                        width: 22,
                        height: 22
                    })
                ),
                canDownload && React.createElement(
                    PlainButton,
                    {
                        type: 'button',
                        className: 'bcpr-btn',
                        onClick: onDownload,
                        title: downloadMsg,
                        'aria-label': downloadMsg
                    },
                    React.createElement(IconDownload, {
                        color: COLOR_999,
                        width: 18,
                        height: 18
                    })
                ),
                onClose && React.createElement(
                    PlainButton,
                    {
                        type: 'button',
                        className: 'bcpr-btn',
                        onClick: onClose,
                        title: closeMsg,
                        'aria-label': closeMsg
                    },
                    React.createElement(IconClose, {
                        color: COLOR_999,
                        width: 24,
                        height: 24
                    })
                )
            )
        )
    );
};

export default injectIntl(Header);